'use client';
import styled, { css } from 'styled-components';

export const Card = styled.div`
  border-radius: 24px;
  border: ${props =>
    props.$checked
      ? `2px solid ${props.theme.colors.secondary.plum}`
      : `1px solid ${props.theme.colors.border.light}`};
  display: inline-flex;
  flex-direction: column;
  user-select: none;
  overflow: hidden; /* prevent overflow on rounded corners */
  position: relative; /* allow absolute positioning of child elements */
  width: 176px;
  height: ${props => (props.$height ? `${props.$height}px` : '80px')};
  background-color: ${({ theme, $unavailable, $bgColor }) =>
    $unavailable
      ? theme.colors.background.disabled
      : $bgColor
      ? theme.colors.background[$bgColor]
      : 'transparent'};
  opacity: ${({ $notSelectable }) => ($notSelectable ? 0.5 : 1)};
  color: ${({ theme }) => theme.colors.text.secondary};

  @media ${props => props.theme.mobileL} {
    width: 185px;
  }
  @media ${props => props.theme.tabletS} {
    width: 265px;
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  padding: ${props => props.theme.spacing(1, 1, 1, 2)};

  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(1, 0, 1, 3)};
  }
`;

export const StyledImage = styled.div`
  border-radius: 16px;
  overflow: hidden;
  object-position: left;
  object-fit: cover;
  max-height: 55px;
  max-width: 55px;
  filter: ${props => props.$unavailable && 'grayscale(100%) brightness(93%)'};
  img {
    height: 100%;
    width: 100%;
  }
  ${props =>
    !props.$checked &&
    !props.$unavailable &&
    css`
      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
    `};

  @media ${props => props.theme.laptop} {
    max-height: 60px;
    max-width: 60px;
  }
`;

export const Info = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};

  max-width: 251px;
  width: 100%;
`;

export const Name = styled.p`
  ${({ theme }) => theme.typography.heading5}
  ${({ theme }) => theme.fontFamily.base}
  text-transform: capitalize;
  line-height: 26px;
  text-align: left;
  padding-left: ${props => props.theme.spacing(1)};

  @media ${props => props.theme.laptop} {
    padding-left: ${props => props.theme.spacing(2)};
  }
`;

export const KeyInfo = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin: ${props => props.theme.spacing(2, 2, 2, 2)};

  width: 100%;
  @media ${props => props.theme.laptop} {
    padding-left: ${({ theme }) => theme.spacing(2)};
    margin: ${props => props.theme.spacing(2, 4, 2, 0)};
  }
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-self: center;
  margin-right: ${({ theme }) => theme.spacing(4)};
  min-width: 28px;
  min-height: 28px;
`;

export const Description = styled.p`
  ${({ theme }) => theme.fontFamily.base};
  text-align: left;
  padding: ${props => props.theme.spacing(0, 4, 2)};
`;
